import React from 'react'
import './Content.css'
// import icon1 from '../../assetsS/images/icon1.png'
import icon2 from '../../assetsS/images/boxicon2.png'
import icon3 from '../../assetsS/images/boxicon1.png'
// import Photo4 from '../../assetsS/images/back4.png'

export default class TextonImage extends React.Component {
  state = {}

  updateDetails() {
    this.props.handleStateChange(this.state)
  }

  componentWillReceiveProps(newProps) {
    this.setState(newProps)
  }

  componentDidMount = async () => {
    this.setState(this.props)
  }

  render() {
    const isBgImg = this.state.isBgImg

    const features = [
      {
        number: '01',
        head: 'Chapter wise testing practice :',
        body: (
          <>
            Once the chapter gets completed the respective teacher can a lot
            test to the students. Students will get the list of questions
            (MCQ's) from that particular chapter. All these MCQ's are carefully
            designed by our specialist board. Our specialist board consist of
            expert educators who will be responsible for creating Questions with
            their vast experience and knowledge.
          </>
        ),
      },
      {
        number: '02',
        head: 'Capability Analysis report:',
        body: (
          <>
            After each test students will get the test results with details
            capability analysis report
            <ul className="spec-list mt-2 mb-0">
              <li>Avg Time taken per each questions subject wise</li>
              <li>Avg Time taken per indirect questions subject wise</li>
              <li>Avg Time taken per direct questions subject wise</li>
              <li>Accuracy rate per subject</li>
              <li>Stamina maintained over the duration of the exam</li>
              <li>Negative answer</li>
            </ul>
          </>
        ),
      },
      {
        number: '03',
        head: 'AI formulates individual students based on the specialized testing practice:',
        body: (
          <>
            Based on the above criteria AI based system suggest following
            testing practice, Speed trainer, Biology champion league, Test
            Marathon
          </>
        ),
      },
      {
        number: '04',
        head: 'Answers & Explanations:',
        body: (
          <>
            Based Once after the exam system provides the answers &amp; detailed
            explanation also the concept behind that particular question helps
            students face any kind of twisted questions
          </>
        ),
      },
    ]

    return (
      <div
        className="homebannerimg1"
        // style={{ backgroundImage: `url(${Photo4})` }}
      >
        <div className="text-overlay1comp25">

          {/* ── Section header ── */}
          <div className="spec-header container">
            <p className="spec-header__eyebrow">Features</p>
            <h2 className="spec-header__headline">
              <span className="spec-header__accent">Features</span> of Competitive Exam
              Testing Practice &amp; Evaluation Management Software
            </h2>
            <div className="spec-header__divider" />
            <p className="spec-header__sub">
              <strong>SARASU NEET</strong> Testing Practice cloud-based test
              management platform app that manages your testing and evaluation
              process of your students who are Doctor aspirants.
            </p>
          </div>

          {/* ── Feature cards ── */}
          <div className="container pb-5">
            <div className="row g-4 pt-2">
              {features.map((f, i) => (
                <div key={i} className="col-12 col-lg-6">
                  <div className="spec-card">
                    <div className="spec-card__bar" />
                    <span className="spec-card__number">{f.number}</span>
                    <h3 className="spec-card__head">{f.head}</h3>
                    <div className="spec-card__body">{f.body}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    )
  }
}